var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./modules/services/toastNotification", "axios", "./modules/utils"], function (require, exports, toastNotification_1, axios_1, utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    axios_1 = __importDefault(axios_1);
    utils_1 = __importDefault(utils_1);
    var notificationMs = 4000;
    var forgotPasswordForm = document.querySelector('#forgotPasswordForm');
    var txtEmailOrUsername = document.querySelector("#txtEmailOrUsername");
    var btnSend = document.querySelector("#btnEnviar");
    var disabledClassesForButton = ['bg-linx-purple-transparent-100', 'text-white', 'cursor-not-allowed'];
    var enabledClassesForButton = ['bg-linx-purple-1100', 'text-white', 'cursor-pointer', 'border-linx-purple-1100', 'hover:border-linx-purple-1200', 'hover:bg-linx-purple-1200'];
    var BASE_URL = 'autosservico';
    var HOLDER_URL = 'titular';
    var LOGIN_URL = 'auth';
    var onLoad = function () {
        txtEmailOrUsername.focus();
        enableSendButton(false);
        txtEmailOrUsername.addEventListener('focusout', onEmailFocusOut);
        txtEmailOrUsername.addEventListener('keyup', tryEnableSendButton);
        forgotPasswordForm === null || forgotPasswordForm === void 0 ? void 0 : forgotPasswordForm.addEventListener('submit', submitForm);
    };
    var submitForm = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, returnUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    formData = new FormData(forgotPasswordForm);
                    returnUrl = utils_1.default.findGetParameter('returnurl');
                    if (returnUrl === null || returnUrl === undefined || returnUrl === '')
                        return [2];
                    return [4, axios_1.default.post(BASE_URL + "/" + HOLDER_URL + "/esqueceu-senha?returnUrl=" + returnUrl, formData)
                            .then(function (response) { return handleRequestSuccess(response.data.message, returnUrl); })
                            .catch(function (error) { return toastNotification_1.ToastNotification.Error(error.response.data.message); })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleRequestSuccess = function (message, returnUrl) {
        toastNotification_1.ToastNotification.Success(message, notificationMs);
        setTimeout(function () {
            window.location.href = BASE_URL + "/" + LOGIN_URL + "/login?returnUrl=" + returnUrl;
        }, notificationMs);
    };
    var onEmailFocusOut = function () {
        var validEmail = isValidEmail();
        if (!validEmail) {
            if (this.value.length > 0)
                toastNotification_1.ToastNotification.Alert('Email inválido', notificationMs);
            enableSendButton(false);
            return;
        }
        tryEnableSendButton();
    };
    var enableSendButton = function (enable) {
        var _a, _b, _c, _d;
        if (!btnSend)
            return;
        if (enable) {
            (_a = btnSend.classList).remove.apply(_a, disabledClassesForButton);
            (_b = btnSend.classList).add.apply(_b, enabledClassesForButton);
        }
        else {
            (_c = btnSend.classList).remove.apply(_c, enabledClassesForButton);
            (_d = btnSend.classList).add.apply(_d, disabledClassesForButton);
        }
        btnSend.disabled = !enable;
    };
    var tryEnableSendButton = function () {
        if (!txtEmailOrUsername) {
            enableSendButton(false);
            return;
        }
        enableSendButton(isValidEmail());
    };
    var isValidEmail = function () {
        var _a;
        return (_a = txtEmailOrUsername === null || txtEmailOrUsername === void 0 ? void 0 : txtEmailOrUsername.checkValidity()) !== null && _a !== void 0 ? _a : false;
    };
    window.addEventListener('load', onLoad);
});
